import { useSearchParams } from 'react-router-dom';
import CommentsContainer from './CommentsContainer';
import LiveChat from './LiveChat';

const WatchPage = () => {
    const [searchParams] = useSearchParams();

    return (
        <div className="px-2 md:px-5 py-3 md:py-5 w-full">
            <div className="flex flex-col lg:flex-row w-full gap-4">
                <div className="w-full lg:flex-1">
                    <iframe
                        className="w-full aspect-video rounded-lg"
                        src={`https://www.youtube.com/embed/${searchParams.get("v")}?autoplay=1&color=white&enablejsapi=1`}
                        title="YouTube video player"
                        allowFullScreen
                    />
                </div>
                <LiveChat />
            </div>
            <CommentsContainer />
        </div>
    )
}

export default WatchPage